import script from "./StudentJenphoneNews.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentJenphoneNews.vue?vue&type=script&setup=true&lang=js"

import "./StudentJenphoneNews.vue?vue&type=style&index=0&id=89cc20ce&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89cc20ce"]])

export default __exports__